var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33398 14V4.66667C5.33398 4.04669 5.33398 3.7367 5.40213 3.48236C5.58707 2.79218 6.12616 2.25308 6.81635 2.06815C7.07068 2 7.38067 2 8.00065 2C8.62063 2 8.93062 2 9.18496 2.06815C9.87514 2.25308 10.4142 2.79218 10.5992 3.48236C10.6673 3.7367 10.6673 4.04669 10.6673 4.66667V14M3.46732 14H12.534C13.2807 14 13.6541 14 13.9393 13.8547C14.1902 13.7268 14.3942 13.5229 14.522 13.272C14.6673 12.9868 14.6673 12.6134 14.6673 11.8667V6.8C14.6673 6.05326 14.6673 5.6799 14.522 5.39468C14.3942 5.1438 14.1902 4.93982 13.9393 4.81199C13.6541 4.66667 13.2807 4.66667 12.534 4.66667H3.46732C2.72058 4.66667 2.34721 4.66667 2.062 4.81199C1.81111 4.93982 1.60714 5.1438 1.47931 5.39468C1.33398 5.6799 1.33398 6.05326 1.33398 6.8V11.8667C1.33398 12.6134 1.33398 12.9868 1.47931 13.272C1.60714 13.5229 1.81111 13.7268 2.062 13.8547C2.34721 14 2.72058 14 3.46732 14Z",
    stroke: "#4D5761",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.578f195f96c85fa2e7e2b363dfada43f.svg";
export { ForwardRef as ReactComponent };